import axios from 'axios';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { apiUrlPublic } from '../../config/config';
import ProductPage from '../components/Product/Product';
import SEO from '../components/shared/SEO';

import { withTranslation } from '../i18n/i18n';

class ProductContainer extends Component {
  static async getInitialProps({ query }) {
    try {
      const fetchProduct = await axios.get(
        `${apiUrlPublic}/product/single/${query ? query.slug : ''}`
      );
      const { product } = await fetchProduct.data;
      return { product, query, namespacesRequired: ['product'] };
    } catch (error) {
      if (error.response) {
        console.log('error', error.response);
      } else {
        console.log('general error, product', error);
      }

      return {
        product: {
          attributes: [],
          attributeSets: [],
          attrs: [],
          description: { long: '', short: '' },
          extras: [],
          hasAttributeSets: false,
          images: [],
          onSale: {},
          options: [],
          ratings: [],
          relatedProducts: [],
          status: {},
          technologies: [],
          variants: [],
          videos: []
        },
        query: '',
        namespacesRequired: ['product']
      };
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product,
      key: 1
    };
  }

  componentDidMount() {
    /* custom scroll always to top */
    const container = document.getElementsByTagName('BODY')[0];
    container.scrollTop = 0;
  }

  // stupid getInitialProps won't force rerender of the component, hacked it with key
  componentDidUpdate(prevProps) {
    const { query } = this.props;
    if (prevProps.query.slug !== query.slug) {
      this.setState({ product: this.props.product, key: this.state.key + 1 });
    }
  }

  render() {
    const { favorites, settings, t } = this.props;
    const { product } = this.state;
    return (
      <div key={this.state.key}>
        <SEO product={product} />
        <ProductPage favorites={favorites} product={product} settings={settings} t={t} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    favorites: state.customer.favorites,
    settings: state.settings
  };
};

export default connect(mapStateToProps)(withTranslation('product')(ProductContainer));
